<div class="block-home">
  <h1>{{ 'credits.creditsFinish' | translate }}</h1>
  <lms-list
    [listId]="listId"
    [serviceProvider]="subscriptionsService"
    (collectionUpdated)="setCollection($event)"
    [options]="listOptions"
  >
    <div class="table">
      <div class="table-heading">
        <lms-list-header [listId]="listId" class="table-item" field="name" label="nouns.name"></lms-list-header>
        <lms-list-header
          [listId]="listId"
          class="table-item"
          field="rateConsumed"
          label="credits.consumedCredits"
        ></lms-list-header>
        <lms-list-header
          [listId]="listId"
          class="table-item"
          field="rateLimit"
          label="credits.header.totalCredits"
        ></lms-list-header>
        <lms-list-header
          [listId]="listId"
          class="table-item"
          field="endDate"
          label="nouns.expirationDate"
        ></lms-list-header>
      </div>
      <div *ngFor="let bag of bags" class="table-row">
        <div class="table-item cursor-pointer">
          <a [routerLink]="['/clients', bag.clientId]" title="{{ 'actions.edit' | translate }} {{ bag.client.name }}">{{
            bag.client.name
          }}</a>
        </div>
        <div class="table-item">{{ bag.rateConsumed }}</div>
        <div class="table-item">{{ bag.rateLimit }}</div>
        <div class="table-item">{{ bag.endDate | date : 'mediumDate' : 'utc-12:00' }}</div>
      </div>
    </div>
  </lms-list>
</div>
